import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// Components
import SearchIcon from 'assets/images/svg/SearchIcon';
// Helpers
import { convertQueryParamsIntoObject, isoStartFormat, isoEndFormat } from 'constants/Helpers';
// Actions
import { setOrdersListData } from 'store/orders/OrdersListActions';
import { getUnassignedBatchesData } from 'store/production/ProductionActions';

const HeaderSearch = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = location.search ? convertQueryParamsIntoObject(location.search) : {};
  const [searchText, setSearchText] = useState('');
  const currentPage = location.pathname.slice(1);
  const navigate = useNavigate();

  const getHandler = (page, e) => {
    switch (page) {
      case 'home':
        return handleSubmit(e);
      case 'orders':
      case 'my-task':
        return handleOrdersSubmit(e);
      case 'production':
        return handleProductionSearch(e);
      default:
        break;
    }
  };

  const placeholderHandler = (page) => {
    switch (page) {
      case 'home':
      case 'orders':
      case 'my-task':
        return 'Search by order ID or SKU';
      case 'production':
        return 'Search by Job ID or Product Name';
      default:
        break;
    }
  };

  const handleProductionSearch = (e) => {
    e.preventDefault();
    if (searchText !== '') {
      dispatch(
        getUnassignedBatchesData(
          {
            jobDetails: searchText.trim(),
          },
          navigate
        )
      );
    } else {
      dispatch(
        getUnassignedBatchesData(
          {
            productionStartDate: isoStartFormat(new Date()),
            productionEndDate: isoEndFormat(new Date()),
          },
          navigate
        )
      );
    }
  };

  // The orders list keeps its filters out of the URL, so the term goes through the store.
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({
      type: 'SET_ORDERS_SEARCH_KEY',
      payload: searchText.trim(),
    });
  };

  const handleOrdersSubmit = (e) => {
    e.preventDefault();
    dispatch(
      setOrdersListData(
        { ...params, page: 1, floristId: -1, searchKey: searchText, isFlorist: true },
        navigate
      )
    );
  };

  return (
    <form className="search-form" onSubmit={(e) => getHandler(currentPage, e)}>
      <input
        id="search-header-input"
        placeholder={placeholderHandler(currentPage)}
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
      />
      <SearchIcon />
    </form>
  );
};

export default HeaderSearch;
